// src/common/components/cartModal/components/checkout-stage/components/deliveryTypeSelector/DeliveryTypeSelector.tsx
import React from "react";
import { useSelector } from "react-redux";
import { DeliveryType } from "../../../../types/enums";

import styles from "./DeliveryTypeSelector.module.scss";
import { useTheme } from "../../../../hooks/useTheme";
import { selectCurrentCluster } from "../../../../../store/slices/currentClusterSlice";
import { getDeliveryTypeIcon } from "../../../../utils/functions/enumToIcon";
import { getDeliveryTypeText } from "../../../../utils/functions/enumToText";
import SelectableCard from "../selectableCard/SelectableCard";

interface Props {
  deliveryType: DeliveryType;
  onSelect: (type: DeliveryType) => void;
}

export default function DeliveryTypeSelector({
  deliveryType,
  onSelect,
}: Props) {
  const { theme } = useTheme();
  const currentCluster = useSelector(selectCurrentCluster);

  const deliveryOptions = [
    {
      type: DeliveryType.DELIVERY,
      icon: getDeliveryTypeIcon(DeliveryType.DELIVERY),
      label: getDeliveryTypeText(DeliveryType.DELIVERY),
    },
    {
      type: DeliveryType.PICKUP,
      icon: getDeliveryTypeIcon(DeliveryType.PICKUP),
      label: getDeliveryTypeText(DeliveryType.PICKUP),
    },
  ];

  return (
    <div className={styles.container}>
      <h3 className={styles.title} style={{ color: theme.text }}>
        Тип доставки
      </h3>
      <div className={styles.optionsContainer}>
        {deliveryOptions
          .filter((el) =>
            !currentCluster?.withDelivery
              ? el.type !== DeliveryType.DELIVERY
              : true,
          )
          .map((option) => (
            <SelectableCard
              key={option.type}
              isSelected={deliveryType === option.type}
              onSelect={() => onSelect(option.type)}
              icon={option.icon}
              label={option.label}
              className={styles.optionCard}
            />
          ))}
      </div>
    </div>
  );
}
